<template>
	<div class="charbox">
		<div class="chartmix" ref="chart" :style="ostyle"></div>
	</div>
</template>
<script>
	import echarts from 'echarts'
	export default {
		props: {
			cheight: String,
			data: [Array, Object],
			ctitle: String,
			//图标标题
			ctype: String,
			//图标类型
			areaStyle: Boolean,
			//line 区域图
			legend: {
				type: Boolean,
				default: true
			},
			toolbox: {
				type: Boolean,
				default: true
			},
			tooltip: {
				type: Boolean,
				default: true
			},
			x: {
				type: Boolean,
				default: true
			},
			y: {
				type: Boolean,
				default: true
			},
			fullcav: Boolean
		},
		data() {
			return {
				chart: null,
				showx: this.x,
				showy: this.y,
				showTit: true,
				showLegend: this.legend,
				boundaryGap: false,
				showToolbox: this.toolbox,
				top: "20%",
				left: "4%",
				right: "4%",
				bottom: "2%",
				full: this.fullcav,
			}
		},
		methods: {
			setChartData() {
				let data = this.chartdata
				let count = 0;
				switch(this.ctype) {
					case 'line':
						data.forEach(item => {
							item.type = 'line';
							item.smooth = true;
						});
						if(!!this.areaStyle) {
							data.forEach(item => {
								item.areaStyle = {
									normal: {}
								}
							})
						}
						break;
					case 'bar':
						data.forEach(item => {
							item.type = 'bar';
							item.barWidth = `${60/data.length}%`
						});
						this.boundaryGap = true;
						break;

					case 'pie':
						data.forEach(item => {
							item.type = 'pie';
						});
						this.showx = false;
						this.showy = false;
						break;

				};
				if(this.full == true) {
					this.top = "0";
					this.left = "-10%";
					this.right = "0";
					this.bottom = "-22%";
				};
				return this.chartdata = data;
			},
			drawChart() {
				this.chart = echarts.init(this.$refs.chart);
				this.chart.setOption({
					title: {
						show: this.showTit,
						text: this.ctitle
					},
					tooltip: {
						show: this.tooltip,
						trigger: 'axis'
					},
					legend: {
						show: this.showLegend,
						data: this.chartdata,
					},
					grid: {
						left: this.left,
						right: this.right,
						bottom: this.bottom,
						top: this.top,
						containLabel: true
					},
					toolbox: {
						show: this.showToolbox,
						feature: {
							saveAsImage: {}
						}
					},
					xAxis: {
						show: this.showx,
						type: 'category',
						boundaryGap: this.boundaryGap,
						data: ['1', '2', '3', '4', '5', '6', '7']
					},
					yAxis: {
						show: this.showy,
						type: 'value'
					},
					series: this.chartdata,
				})
			}
		},
		computed: {
			ostyle() {
				return {
					height: this.cheight + 'px'
				}
			},
			chartdata() {
				return this.data
			},
			showTit() {
				return this.ctitle ? true : false
			}
		},
		mounted() {
			this.setChartData();
			this.$nextTick(function() {
				this.drawChart();
			})
		}
	}
</script>
<style lang="less">
	@import (reference) "../../assets/lib/css.less";
	.cavmix-box {
		.ohd;
		.mgl(-15px);.mgr(-15px);
	}
</style>


// WEBPACK FOOTER //
// chart.vue?c91fe228